import { createAction, props } from '@ngrx/store'
import { LoginHistory } from './login-history.state'

export const loadLoginHistories = createAction(
  '[Login History] Load Login Histories',
  props<{
    params?: string | null
    page?: number
    limit?: number
  }>()
)

export const loadLoginHistoriesSuccess = createAction(
  '[Login History] Load Login Histories Success',
  props<{
    loginHistories: LoginHistory[]
    totalCount: number
    totalRowCount: number
    failedLoginCount: number
    loggedOutLoginCount: number
    successfulLoginCount: number
  }>()
)

export const loadLoginHistoriesFailure = createAction(
  '[Login History] Load Login Histories Failure',
  props<{
    error: string
  }>()
)

export const resetLoginHistoryState = createAction('[Login History] Reset State')
